module.exports = __webpack_public_path__ + "static/media/junitaisen.ca9ba4b0.jpg";